import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. El kit está pensado para empezar desde cero, incluso si nunca hiciste flores de chenille ni manualidades similares.'
}, {
  q: '¿Qué materiales necesito?',
  a: 'Principalmente limpiapipas/chenille y algunos materiales simples de apoyo. Dentro del kit vas a encontrar una guía de materiales para saber qué preparar.'
}, {
  q: '¿Los videos están incluidos?',
  a: 'Sí. Ambos kits incluyen videos tutoriales de apoyo para acompañar el aprendizaje paso a paso.'
}, {
  q: '¿Cuál es la diferencia entre el Kit Inicial y el Mega Kit?',
  a: 'El Kit Inicial es ideal para aprender desde cero con 10 flores simples. El Mega Kit incluye más modelos, armado de ramos, +100 ideas de inspiración y una guía de emprendimiento.'
}, {
  q: '¿Puedo vender lo que cree?',
  a: 'Sí. Podés vender las flores, ramos, llaveros, cuadros, souvenirs o detalles que hagas con la técnica aprendida.'
}, {
  q: '¿Cómo accedo al contenido?',
  a: 'Es un producto digital. Después de la compra, accedés al material para descargar o consultar desde tu dispositivo.'
}, {
  q: '¿El acceso es inmediato?',
  a: 'Sí. El acceso al producto es inmediato después de la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-52">
      <div className="text-center mb-8 sm:mb-10 px-2" data-id="element-53">
        <h2 className="text-3xl sm:text-4xl text-deco-text mb-4 font-bold leading-tight" data-id="element-54">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-3 sm:space-y-4" data-id="element-55">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-[1.5rem] border border-deco-warm overflow-hidden shadow-sm" data-id="element-56">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-deco-bg transition-colors" data-id="element-57">
              <span className="font-serif font-bold text-base sm:text-lg text-deco-text pr-6 leading-tight" data-id="element-58">
                {faq.q}
              </span>
              <ChevronDown className={`text-deco-terra shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-59" />
            </button>

            <AnimatePresence data-id="element-60">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-61">
                  <div className="px-6 pb-6 pt-1 text-deco-text/80 leading-relaxed font-normal text-sm sm:text-base border-t border-deco-warm/50" data-id="element-62">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}